import Svg, { Mask, Path } from '@rd-core-svg/svg'
import type { FlagsSvgProps } from '../svg.types'

export const BancoDoBrasilMedium = (props: FlagsSvgProps) => {
  return (
    <Svg width={48} height={32} viewBox="0 0 48 32" fill="none" {...props}>
      <Mask id="path-1-inside-1_22078_4099" fill="white">
        <Path d="M0 4C0 1.79086 1.79086 0 4 0H44C46.2091 0 48 1.79086 48 4V28C48 30.2091 46.2091 32 44 32H4C1.79086 32 0 30.2091 0 28V4Z" />
      </Mask>
      <Path
        d="M0 4C0 1.79086 1.79086 0 4 0H44C46.2091 0 48 1.79086 48 4V28C48 30.2091 46.2091 32 44 32H4C1.79086 32 0 30.2091 0 28V4Z"
        fill="#FDE100"
      />
      <Path
        d="M4 0V1H44V0V-1H4V0ZM48 4H47V28H48H49V4H48ZM44 32V31H4V32V33H44V32ZM0 28H1V4H0H-1V28H0ZM4 32V31C2.34315 31 1 29.6569 1 28H0H-1C-1 30.7614 1.23858 33 4 33V32ZM48 28H47C47 29.6569 45.6569 31 44 31V32V33C46.7614 33 49 30.7614 49 28H48ZM44 0V1C45.6569 1 47 2.34315 47 4H48H49C49 1.23858 46.7614 -1 44 -1V0ZM4 0V-1C1.23858 -1 -1 1.23858 -1 4H0H1C1 2.34315 2.34315 1 4 1V0Z"
        fill="#E6E6E6"
        mask="url(#path-1-inside-1_22078_4099)"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.9997 12.3335L17.5787 15.3891L23.0787 11.7224L20.7892 10.1903L23.7673 8.21068L30.1797 12.4885L19.6445 19.5119L21.934 21.044L34.9997 12.3335L23.9997 5.00015L12.9997 12.3335ZM34.9997 19.6668L30.4121 16.6113L24.9121 20.2779L27.2016 21.8014L24.2235 23.7897L17.8111 19.5119L28.3463 12.4885L26.0568 10.9564L12.9997 19.6668L23.9997 27.0002L34.9997 19.6668ZM34.9997 8.0557L32.7016 9.58783L30.4121 8.0557L34.9997 5.00015V8.0557ZM12.9997 23.9446L15.2892 22.4125L17.5787 23.9446L12.9997 27.0002V23.9446Z"
        fill="#003882"
      />
    </Svg>
  )
}
